import * as React from 'react';
/** @hidden */
export var COLLECTION_ACTION;
(function (COLLECTION_ACTION) {
    COLLECTION_ACTION[COLLECTION_ACTION["add"] = 0] = "add";
    COLLECTION_ACTION[COLLECTION_ACTION["remove"] = 1] = "remove";
})(COLLECTION_ACTION || (COLLECTION_ACTION = {}));
/** @hidden */
export var useCollection = function (initial) {
    if (initial === void 0) { initial = []; }
    var collection = React.useRef(initial);
    var handleCollectionAction = React.useCallback(function (action) {
        switch (action.type) {
            case COLLECTION_ACTION.add:
                collection.current.push(action.item);
                break;
            case COLLECTION_ACTION.remove:
                var index = collection.current.indexOf(action.item);
                collection.current.splice(index, 1);
                break;
            default:
                break;
        }
    }, []);
    return [collection.current, handleCollectionAction];
};
//# sourceMappingURL=useCollection.js.map